import { NgModule } from '@angular/core';

import { SharedDependenciesModule } from '../../../../shared/shared-dependencies.module';

import { BackupItemComponent } from './backup-item/backup-item.component';
import { BackupListComponent } from './backup-list/backup-list.component';
import { BackupLoaderComponent } from './backup-loader/backup-loader.component';
import { BackupVddTableItemComponent } from './backup-vdd-table-item/backup-vdd-table-item.component';
import { BackupVddTableComponent } from './backup-vdd-table/backup-vdd-table.component';
import { BackupComponent } from './backup.component';

@NgModule({
  imports: [SharedDependenciesModule],
  exports: [BackupComponent, BackupItemComponent, BackupLoaderComponent, BackupVddTableComponent],
  declarations: [
    BackupComponent,
    BackupItemComponent,
    BackupListComponent,
    BackupLoaderComponent,
    BackupVddTableComponent,
    BackupVddTableItemComponent,
  ],
})
export class BackupModule {}
